// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1HZTh","empty":"ModalGraph_empty__3Dvep"};